/**
 * CategoryListPresenter
 * --
 */
import React, { useEffect, useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  InputFormTable,
  Information,
  Pagination,
  Tree,
} from 'components';
import { Button, Radio, DatePicker, Input, Select, Tag } from 'antd';
import {
  FileOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';

const tData = [
  {
    title: '커피',
    key: '1',
    children: [
      {
        title: '아메리카노',
        key: '3',
        children: [
          {
            title: '아이스',
            key: '9',
          },
          {
            title: '핫',
            key: '10',
          },
        ],
      },
      {
        title: '카페 라떼',
        key: '4',
      },
      {
        title: '바닐라 라떼',
        key: '5',
      },
    ],
  },
  {
    title: '에이드',
    key: '2',
    children: [
      {
        title: '오렌지 에이드',
        key: '6',
      },
      {
        title: '청포도 에이드',
        key: '7',
      },
    ],
  },
  {
    title: '텀블러',
    key: '8',
  },
];

const CategoryListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [treeData, setTreeData] = useState(tData);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [inputValue, setInputValue] = useState('신규 카테고리');
  const [tabKey, setTabKey] = useState(1);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'상품명'}
                options={[
                  { label: '상품명', value: '상품명' },
                  { label: '회원명', value: '회원명' },
                  { label: '전화번호', value: '전화번호' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
              <Button size="large" icon={<PlusOutlined />} />
            </>
          ),
        },
      ],
    },
    {
      label: '상품 구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'기본상품'}>기본상품</Radio>
                <Radio value={'세트상품'}>세트상품</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '상품 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '상품 등록일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'진열함'}>진열함</Radio>
                <Radio value={'진열안함'}>진열안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매함'}>판매함</Radio>
                <Radio value={'판매안함'}>판매안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      no: i + 1,
      카테고리: '커피/원두',
      상품코드: `0000000`,
      상품명: (
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <Tag
            style={{
              background: 'none',
              color: i === 0 ? '#37383C' : i < 8 ? '#58CF04' : '#EAA300',
              borderColor: i === 0 ? '#37383C' : i < 8 ? '#58CF04' : '#EAA300',
              width: 48,
              fontSize: 8,
              fontWeight: 600,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {i === 0 ? '심사대기' : i < 8 ? '판매중' : '반려'}
          </Tag>
          [과테말라] 디카페인 200g
        </p>
      ),
      판매가: 20000,
      수량: 57400,
      판매처: 'JM커피',
    });
  }

  const form = [
    {
      label: '카테고리 번호',
      form: [
        {
          input: <p>{isCreating ? '' : selectedItem?.key}</p>,
        },
      ],
    },
    {
      label: '카테고리 명',
      form: [
        {
          input: (
            <>
              <Input
                placeholder="카테고리 명을 입력하세요."
                style={{ ...styles.form.input.large }}
                value={isCreating ? inputValue : selectedItem?.title}
                onChange={(e) =>
                  isCreating
                    ? setInputValue(e.target.value)
                    : setSelectedItem({
                        ...selectedItem,
                        title: e.target.value,
                      })
                }
              />
            </>
          ),
          count: true,
          maxLength: 10,
        },
      ],
    },
    {
      label: '표시여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'표시'}>
                <Radio value={'표시'}>표시</Radio>
                <Radio value={'표시안함'}>표시안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 카테고리 추가
   * --
   */
  const handleAddCategory = () => {
    setIsCreating(!isCreating);

    const child = {
      title: inputValue,
      key: '-',
    };
    const addChildToTree = (tree, key, newChild) => {
      return tree.map((node) => {
        if (node.key === key) {
          return {
            ...node,
            children: node.children ? [...node.children, newChild] : [newChild],
          };
        }

        if (node.children) {
          return {
            ...node,
            children: addChildToTree(node.children, key, newChild),
          };
        }

        return node;
      });
    };

    const newTreeData = selectedItem
      ? addChildToTree(treeData, selectedItem.key, child)
      : [...treeData, child];
    setTreeData(newTreeData);
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (!isCreating) {
      setTreeData(tData);
    }
  }, [isCreating]);

  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>카테고리 목록</Title>
          </Col>

          <Col x={4}>
            <Content
              maxWidth={'100%'}
              padding={5}
              backgroundColor="none"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
              }}
            >
              <Button
                size="small"
                style={{
                  borderColor: 'var(--primary-color)',
                  color: 'var(--primary-color)',
                }}
                onClick={() => handleAddCategory()}
              >
                카테고리 추가 +
              </Button>

              {selectedItem && (
                <Button
                  size="small"
                  style={{ borderColor: '#F94F1A', color: '#F94F1A' }}
                >
                  삭제
                </Button>
              )}
            </Content>
            <Content maxWidth={'100%'} backgroundColor="none">
              <Tree
                data={treeData}
                icon={{
                  0: ({ collapsed }) =>
                    collapsed ? <FolderOutlined /> : <FolderOpenOutlined />,
                  1: () => <FileOutlined />,
                }}
                onSelect={(key, item) => {
                  if (item.key === key) setIsCreating(false);

                  setSelectedItem(item);
                }}
                onDeSelect={(key, item) => setSelectedItem(null)}
              />
            </Content>
          </Col>
          <Col x={20}>
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor="none"
              style={{
                borderLeft: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
              }}
            >
              {selectedItem ? (
                <Content maxWidth={'100%'} style={{ marginBottom: 40 }}>
                  <ul
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                      width: '100%',
                      marginBottom: 10,
                    }}
                  >
                    {[
                      { label: '카테고리 설정', key: 1 },
                      { label: '카테고리 상품관리', key: 2 },
                    ].map((_item, _index) => (
                      <li
                        key={`tab_${_index}`}
                        onClick={() => setTabKey(_item.key)}
                        style={{
                          border: '1px solid #000',
                          borderColor:
                            tabKey === _item.key ? '#000' : '#B6AEAE',
                          borderBottom:
                            tabKey === _item.key ? 'none' : '1px solid #000',
                          fontSize: 14,
                          fontWeight: tabKey === _item.key ? 600 : 400,
                          color: tabKey === _item.key ? '#000' : '#B6AEAE',
                          padding: '10px 20px',
                          cursor: 'pointer',
                          display:
                            isCreating && _item.key === 2
                              ? 'none'
                              : 'inline-block',
                        }}
                      >
                        {_item.label}
                      </li>
                    ))}
                    <li
                      style={{
                        flex: 1,
                        borderBottom: '1px solid var(--black-color)',
                      }}
                    ></li>
                  </ul>
                  {tabKey === 1 ? (
                    <>
                      {/* 카테고리 설정 */}
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        backgroundColor={'none'}
                      >
                        <Information
                          content={[
                            '탭별 카테고리 설정은 표시여부에 따라 메인 화면에 반영됩니다.',
                            '카테고리 설정은 최종적으로 [저장] 버튼을 클릭 후 반영됩니다.',
                            '카테고리 번호는 저장 후에 생성 됩니다.',
                            '카테고리에 맵핑 되는 상품은 추가/수정 가능합니다.',
                          ]}
                        />
                        <div style={{ marginTop: 10 }}>
                          <InputFormTable form={form} />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Button
                            size="large"
                            type="primary"
                            style={{
                              background: 'var(--primary-color)',
                              marginTop: 40,
                            }}
                          >
                            {isCreating ? '카테고리 생성' : '변경사항 저장'}
                          </Button>
                        </div>
                      </Content>
                      {/* 카테고리 설정 끝 */}
                    </>
                  ) : (
                    <>
                      {/* 카테고리 상품관리 */}
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        backgroundColor={'none'}
                      >
                        <ExpandableContainer borderRadius={4} padding={20}>
                          {formItem.map((_item, _index) => (
                            <div
                              key={`form_${_index}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 0px',
                              }}
                            >
                              <div
                                style={{
                                  width: 120,
                                  fontSize: 13,
                                  fontWeight: 400,
                                }}
                              >
                                <label>{_item.label}</label>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {_item.form.map((_subitem, _subkey) => (
                                  <React.Fragment key={`input_${_subkey}`}>
                                    {_subitem.input}
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          ))}
                        </ExpandableContainer>

                        {/* 검색/초기화 버튼 */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginTop: 48,
                          }}
                        >
                          <Button
                            size="large"
                            type="primary"
                            style={{
                              ...styles.button,
                              background: 'var(--primary-color)',
                            }}
                          >
                            검색
                          </Button>
                          <Button size="large" style={{ ...styles.button }}>
                            초기화
                          </Button>
                        </div>
                        {/* 검색/초기화 버튼 끝 */}
                      </Content>
                      {/* 카테고리 상품관리 끝 */}
                    </>
                  )}
                </Content>
              ) : (
                <div
                  style={{
                    height: 300,
                    marginBottom: 40,
                    background: '#FFFFFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ fontSize: 25 }}>카테고리를 선택해주세요</p>
                </div>
              )}

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>0</span>건
                </h4>
                <Table
                  isChecked
                  data={newData}
                  columns={[
                    {
                      title: '상품번호',
                      key: 'no',
                      width: 50,
                    },
                    {
                      title: '카테고리',
                      key: '카테고리',
                    },
                    {
                      title: '상품명',
                      key: '상품명',
                    },
                    {
                      title: '판매가',
                      key: '판매가',
                      render: (item) => stringToMoneyFormat(item, '원'),
                    },
                    {
                      title: '수량',
                      key: '수량',
                      render: (item) => stringToMoneyFormat(item, '개'),
                    },
                    {
                      title: '판매처',
                      key: '판매처',
                      render: (item) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                  ]}
                />
                <Pagination total={50} style={{ marginTop: 40 }} />
              </Content>
              {/* 검색결과 끝 */}

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{ background: 'var(--primary-color)', marginTop: 40 }}
                >
                  상품 카테고리 등록
                </Button>
              </div>
            </Content>
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default CategoryListPresenter;
